import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/oanda_loader.gif'


const _withScopeId = n => (_pushScopeId("data-v-7bc555ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader__gif",
  src: _imports_0,
  alt: ""
}
const _hoisted_2 = {
  key: 1,
  class: "circular",
  viewBox: "25 25 50 50"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "path",
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none",
  "stroke-width": "3",
  "stroke-miterlimit": "10"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'loader',
            _ctx.isLocked ? 'active' : '',
            !_ctx.isInitComplete ? 'opaque' : '',
            _ctx.isLoaderText ? 'text' : '',
        ])
  }, [
    (_ctx.UtilityHelper.isOandaPath())
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4)),
    (_ctx.isLoaderText && !_ctx.isLoadingThumbnail)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.pictureLoaderText`)), 1))
      : _createCommentVNode("", true),
    (_ctx.isLoaderText && _ctx.isLoadingThumbnail)
      ? (_openBlock(), _createElementBlock("h2", {
          key: 3,
          class: "pt-200",
          innerHTML: _ctx.$t(`${_ctx.TRANSLATION_KEY}.pictureVerificationText`)
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true)
  ], 2))
}